<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. bar1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Url :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.url"
                  :rules="validationRules.url"
                  required
                  placeholder="E.g. https://projectName.ngrok.io/openCashDrawer?printer=bar1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Está Activo? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-radio-group v-model="input.active" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {
  cashDrawersCollection,
  updateCashDrawer,
  saveCashDrawer,
  getCashDrawerById
} from "@/collections/cashDrawer";
import moment from "moment";
import Loader from "../../common/Loader";

export default {
  name: "cash-drawer-dialog",
  components: { Loader },
  data: () => ({
    itemId: "addCashDrawer",
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
      url: [v => (!!v && !!v.trim()) || "Url es requerido"]
    },
    cashDrawers: [],
    input: {
      name: "",
      url: "",
      active: true
    },
    dialogLoader: true
  }),
  firestore() {
    return {
      cashDrawers: cashDrawersCollection
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addCashDrawer") {
          let found = this.cashDrawers.some(
            x =>
              x.name.toLowerCase().trim() ===
              this.input.name.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Create New
          await saveCashDrawer(this.buildCashDrawer());
        } else {
          // check update unique name
          let found = this.cashDrawers.some(
            x =>
              x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim() && x.id !== this.itemId
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Update Existing
          await updateCashDrawer(this.itemId, this.buildCashDrawer());
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
      }

      this.showSuccessMessage("Cajón guardado");

      this.close();
    },
    buildCashDrawer() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (this.itemId === "addCashDrawer") {
        setTimeout(() => {
          this.title = "Crear Cajón";
        }, 100);
        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar Cajón";
        }, 100);
      }

      setTimeout(async () => {
        let cashDrawer = await getCashDrawerById(this.itemId);
        if (cashDrawer) {
          this.input = cashDrawer;
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.input = {
        name: "",
        url: "",
        active: false
      };
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped lang="scss"></style>
